<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';

interface Props extends Pick<ButtonProps, 'size' | 'disabled'> {
	dataTestid?: string;
}

const { dataTestid = 'picker-set-to-now' } = defineProps<Props>();

defineEmits<{ click: [] }>();
</script>

<template>
	<DButton
		type="button"
		color="neutral"
		variant="ghost"
		:size
		:disabled
		:data-testid
		@click="$emit('click')"
	>
		{{ $t('date_range_picker.set_to_now') }}
	</DButton>
</template>
